<template>
  <div class="device_control_page_wraper">
    <div class="close_img_top">
      <img
        src="~assets/img/controlpublic/control-guanbi-chahao.png"
        @click="$closeControlToast"
        alt
      />
    </div>
    <div class="devce_name z_ellipsis1">{{ objData.remark }}</div>
    <div class="content027_wraper">
      <div class="data_027show">
        <div class="data_show_one">
          <div class="data_var_text">
            <span class="data_var_number z_ellipsis1">
              {{ serve027ShowData.businessId1 }}
              <span class="data_var_unit data_shuxiangfengexian">V</span>
            </span>
          </div>
          <div class="data_const_text">当前电压</div>
        </div>
        <div class="data_show_one data_hengxiangfengexian">
          <div class="data_var_text">
            <span class="data_var_number z_ellipsis1">
              {{ serve027ShowData.businessId2 }}
              <span class="data_var_unit">A</span>
            </span>
          </div>
          <div class="data_const_text">当前电流</div>
        </div>
        <div class="data_show_one">
          <div class="data_var_text">
            <span class="data_var_number z_ellipsis1">
              {{ serve027ShowData.businessId3 }}
              <span class="data_var_unit data_shuxiangfengexian">W</span>
            </span>
          </div>
          <div class="data_const_text">当前功率</div>
        </div>
        <div class="data_show_one">
          <div class="data_var_text">
            <span class="data_var_number z_ellipsis1">
              {{ serve027ShowData.businessId4 }}
              <span class="data_var_unit">度</span>
            </span>
          </div>
          <div class="data_const_text">当前累计电量</div>
        </div>
      </div>
      <div
        class="device_control_btn public_control_btn"
        :class="userControlData.openState ? 'public_control_btn_on' : ''"
        @click="device027BtnClickHandle"
      >{{ deviceStateComputed }}</div>
    </div>
    <div @click="zhouQiDingShiBtnHandle" class="text027_go_wraper">
      <span class="text027">周期定时设置</span>
      <img src="~assets/img/controlpublic/bai_youjiantou.png" alt class="go027_img" />
    </div>
    <div @click="xunHuanDingShiBtnHandle" class="text027_go_wraper">
      <span class="text027">循环定时设置</span>
      <img src="~assets/img/controlpublic/bai_youjiantou.png" alt class="go027_img" />
    </div>
    <div @click="liShiDianLiangBtnHandle" class="text027_go_wraper">
      <span class="text027">历史电量统计</span>
      <img src="~assets/img/controlpublic/bai_youjiantou.png" alt class="go027_img" />
    </div>
  </div>
</template>

<script>
import { controlBtnRequestHandle } from "components/content/control-toast/control-toast-classify/device-public-js";
import vm from "@/main";
import store from "store/index"; ///导入公共仓库

import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from "components/content/contro-view/device-view/device-item-view-js";
export default {
  data() {
    return {
      userControlData: {
        openState: this.objData.openState, ///1开 或0关
        openStateValue: this.objData.openStateValue, //无用
        openStateValue1: this.objData.openStateValue1, ///无用
        openStateValue2: this.objData.openStateValue2 ///无用
      }
    };
  },
  props: {
    objData: Object, ///要控制场景的数据
    serve027ShowData: Object ////要展示的数据
  },
  methods: {
    device027BtnClickHandle() {
      deviceStateFlip(this.userControlData);
      console.log(this.userControlData.openState + "用户的设置数据");
      controlBtnRequestHandle(this.userControlData, this.objData); ///控制请求服务端的公共方法
    },
    zhouQiDingShiBtnHandle() {
      console.log("周期定时按钮被点击了");
      // 获取设备详情 接口，获取数据
      vm.$request({
        method: "post",
        url: "/device/findDeviceById",
        data: {
          token: store.state.token,
          deviceId: this.objData.deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            vm.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了 数据地址存到仓库
            store.dispatch("asyUpdataServeOneObjectinfo", res.data.data); ///异步提交对象信息地址到仓库
            vm.$closeControlToast(); ///关闭控制弹窗
            vm.$router.push("/DeviceManageMain/cycleTask027Config");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    xunHuanDingShiBtnHandle() {
      console.log("循环定时按钮被点击了");

      ///获取插座循环定时信息 接口，获取数据
      vm.$request({
        method: "post",
        url: "/device/findLoopTimeById",
        data: {
          token: store.state.token,
          deviceId: this.objData.deviceId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveDeviceDetailsData = res.data.data ////拿到服务器返回的数据结果

            // 20200425补BUGPC端同步 ,这里其实应该是传设备详情,但是没有必要在请求一下接口了,就用设备控制信息代替了
            store.dispatch("asyUpdataServeOneObjectinfo", this.objData); ///异步提交对象信息地址到仓库

            console.log(res.data.data);
            store.dispatch("asyUpdataserveOneLoopTask027Data", res.data.data); ///异步提交信息到仓库
            vm.$closeControlToast(); ///关闭控制弹窗

            vm.$router.push("/DeviceManageMain/changeLoopTask");

            // this.$showTipsToast(1, '下载成功', true) ////提示框
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    liShiDianLiangBtnHandle() {
      console.log("历史电量按钮被点击控制页面");

      vm.$router.push({
        path: "/DeviceManageMain/HistoricalElectricity027Page",
        query: {
          deviceId: this.objData.deviceId
        }
      });
      vm.$closeControlToast(); ///关闭控制弹窗

      // vm.$toast('暂未开放')
    }
  },
  computed: {
    deviceStateComputed() {
      if (this.userControlData.openState === 1) {
        return "已打开";
      } else {
        return "已关闭";
      }
    }
  },
  watch: {
    "objData.openState": {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val);
        this.userControlData.openState = val;
      }
    }
  }
};
</script>

<style>
.data_027show {
  /* width: 250px; */

  display: flex;

  flex-direction: row;
  flex-wrap: wrap;

  justify-content: center;
  align-items: center;
  align-content: center;
}
.device_control_btn {
  border: 1px solid var(--control-outline-color);
  margin: 20px 25px;
}

.data_show_one {
  width: 139px;
  height: 80px;
  /* flex: 1; */

  display: flex;

  flex-direction: column;
  flex-wrap: nowrap;

  justify-content: center;
  align-items: center;

  position: relative;
}
.data_shuxiangfengexian::after {
  content: "";
  display: inline-block;
  height: 30px;
  width: 1px;
  background-color: #999999;

  position: absolute;
  top: 30px;
  right: 0;
}
.data_hengxiangfengexian::after {
  content: "";
  display: inline-block;
  height: 1px;
  width: 220px;
  background-color: #999999;

  position: absolute;
  bottom: 0px;
  right: 29px;
}
.data_var_text {
  height: 35px;
  /* line-height: 35px; */
}
.data_var_number {
  display: inline-block;
  height: 35px;
  font-size: 22px;
  width: 130px;
  text-align: center;
}
.data_var_unit {
  font-size: 12px;
  margin-left: 3px;
  color: #999999;
}
.data_const_text {
  font-size: 12px;
  margin-top: 2px;
  color: #999999;
}

.content027_wraper {
  width: 298px;
  height: 250px;
  border: 1px solid var(--control-outline-color);
  border-radius: 4px;

  margin: 18px 0px;
}
.text027_go_wraper {
  height: 40px;
  line-height: 40px;
  width: 100%;
  /* color: #999999; */

  position: relative;
}
.text027_go_wraper::after {
  content: "";
  display: inline-block;
  width: 298px;
  height: 1px;
  background-color: #999999;

  position: absolute;
  bottom: 0px;
  right: 4px;
}
.go027_img {
  width: 14px;
  height: 14px;
  /* margin-bottom: -2px; */
  position: absolute;
  right: 0px;
  top: 12px;
}
</style>
